import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { GuestService } from '../modules/core/services/guest.service';

import * as fromRoot from '../reducers';
import { Store } from '@ngrx/store';
import { CONSTANTS } from '../constants/constants';
import { BookingService } from '../modules/core/services/booking.service';
import { navGuardUtil } from '../utils/nav-guard.util';
import { Observable } from 'rxjs';
 
export const arrivalTimeNavigationGuard: CanActivateFn = (): Observable<any> => {

	const store: Store<fromRoot.AppState> = inject(Store<fromRoot.AppState>);
	const guestService: GuestService = inject(GuestService);
	const bookingService: BookingService = inject(BookingService);
	const router: Router = inject(Router);
	const constants: any = inject(CONSTANTS); 

	return navGuardUtil({
      store: store,
      router: router,
      routePath: constants.ROUTES.SELECT_GUESTS_FOR_CHECKIN,
      routeErrorPath: constants.ROUTES.ERROR,
      isProgressBarEnabled: bookingService.isProgressBarEnabled,
      infoCompleted: guestService.isCruiseDetailsCompleted
    }); 
}
